import React from 'react';

interface TextToggleProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    disabled?: boolean;
    size?: 'smaller' | 'small' | 'medium' | 'large';
    text?: string;
}

const SIZE_MAP = {
    smaller: { width: 50, height: 14, knob: 10, font: 12, textSize: 9 },
    small:   { width: 60, height: 16, knob: 12, font: 16, textSize: 10 },
    medium:  { width: 70, height: 20, knob: 16, font: 22, textSize: 12 },
    large:   { width: 90, height: 26, knob: 20, font: 28, textSize: 14 },
};

const TextToggle: React.FC<TextToggleProps> = ({ 
    checked, 
    onChange, 
    label, 
    disabled, 
    size = 'medium',
    text = ''
}) => {
    const dims = SIZE_MAP[size] || SIZE_MAP['medium'];
    
    return (
        <label
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                cursor: disabled ? 'not-allowed' : 'pointer',
                gap: 12,
                fontSize: dims.font,
                fontWeight: 400,
                color: 'var(--color-default-text)',
                userSelect: 'none',
            }}
        >
        <span
            style={{
                width: dims.width,
                minWidth: dims.width,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <span
                style={{
                    width: dims.width,
                    height: dims.height,
                    borderRadius: 24,
                    background: checked ? 'var(--color-primary)' : '#00000025',
                    position: 'relative',
                    transition: 'background 0.2s',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                }}
            >
                <span
                    style={{
                        fontSize: dims.textSize,
                        fontWeight: 600,
                        color: checked ? '#fff' : 'var(--color-text-muted)',
                        transition: 'color 0.2s',
                        zIndex: 1,
                        textAlign: 'center',
                        padding: '0 4px',
                    }}
                >
                    {text}
                </span>
                <span
                    style={{
                        position: 'absolute',
                        left: checked ? dims.width - dims.knob - 2 : 2,
                        top: (dims.height - dims.knob) / 2,
                        width: dims.knob,
                        height: dims.knob,
                        borderRadius: '50%',
                        background: 'var(--color-page-background)',
                        boxShadow: '0 1px 4px #e5e7eb',
                        transition: 'left 0.2s',
                    }}
                />
            <input
                type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={e => onChange(e.target.checked)}
                    style={{
                    opacity: 0,
                    width: dims.width,
                    height: dims.height + 4,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    margin: 0,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                }}
            />
            </span>
        </span>
        {label && <span style={{ fontSize: 14, color: 'var(--color-default-text)', fontWeight: 400 }}>{label}</span>}
        </label>
    );
};

export default TextToggle;
